import { Schema } from '@gitbook/slate';

import { BLOCK_DIVIDER } from '../types';

/**
 * Schema to validate divider nodes.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_DIVIDER]: {
            isVoid: true,
        },
    },
});
